


















import { Vue, Component, Prop } from 'vue-property-decorator'
import { debounce } from 'lodash-es'
import { getCountryList } from '@/service/common'

export interface Country {
  country_code: string;
  country_name: string;
}

let countries: Promise<Country[]>
export function getCountries() {
  return countries || (countries = getCountryList())
}

@Component({
  inheritAttrs: false,
  model: { event: 'change' }
})
export default class CountrySelect extends Vue {
  @Prop({ required: true }) value!: string
  dataSource: Country[] = []
  options: Country[] = []
  open = false
  handleSearch = debounce(this.onSearch, 200)

  async created() {
    this.dataSource = this.options = await getCountries()
  }

  onSearch(query: string) {
    query = query.trim()
    if (!query) {
      this.options = this.dataSource
      return
    }
    this.options = this.dataSource.filter(({ country_code, country_name }) => {
      return [country_code, country_name].some(value =>
        value.toUpperCase().startsWith(query.toUpperCase())
      )
    })
  }
}
